import React, { ReactElement } from 'react';
import PropTypes from 'prop-types';
import { Link, LinkProps, useMatch, useResolvedPath } from 'react-router-dom';
import { SidebarItem } from '@epo/epods-react-components/lib/Components/Sidebar';

interface Props extends LinkProps {
    label: string;
    icon: string;
    external?: boolean;
}

const NavItem = ({ to, label, icon, external, ...props }: Props): ReactElement => {
    const resolved = useResolvedPath(to);
    const match = useMatch({ path: resolved.pathname, end: true });
    const externalProps = external ? {
        target: "_blank",
        rel: "noreferrer",
    } : {}

    return (
        <Link style={{ textDecoration: "none" }} {...externalProps} to={to} {...props}>
             <SidebarItem icon={icon} isactive={match ? "true" : "false"} as="button">
                {label}
            </SidebarItem>
        </Link>
    );
};

NavItem.propTypes = {
    to: PropTypes.string.isRequired,
    label: PropTypes.string.isRequired,
    icon: PropTypes.string.isRequired,
};

export default NavItem;
